import React from "react"
import { Link } from "gatsby"

const StyledButton = props => {
  // Tailor the following test to your environment.
  // This example assumes that any internal link (intended for Gatsby)
  // will start with exactly one slash, and that anything else is external.
  const internal = /^\/(?!\/)/.test(props.path)

  let style = "btn btnPrimary"

  if (props.type === "link") {
    style = "simpleLink"
  } else if (props.type === "transparent") {
    style = "btn btnLight"
  }

  const extraClass = props.extraClass ? " " + props.extraClass : ""

  let path

  if (props.path && props.path.includes("internal:")) {
    path = props.path.replace("internal:", "")
  } else {
    path = props.path
  }

  // Use Gatsby Link for internal links, and <a> for others
  if (internal) {
    return (
      <Link className={style + extraClass} to={path} aria-label={props.title}>
        <span>{props.title}</span>
      </Link>
    )
  }

  return (
    <Link
      href={path}
      className={style + extraClass}
      rel="noreferrer"
      target={"_blank"}
      aria-label={props.title}
    >
      <span>{props.title}</span>
    </Link>
  )
}
export default StyledButton
